import { Loader2, PackageOpen, AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LoadingState({ label = "Loading…", rows = 6 }) {
  return (
    <div data-testid="loading-state" className="rounded-lg border border-stone-200 bg-white overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3 text-sm text-muted-foreground border-b border-stone-100">
        <Loader2 className="h-4 w-4 animate-spin text-amber-700" /> {label}
      </div>
      <div className="divide-y divide-stone-100">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex gap-4 px-4 py-3">
            {Array.from({ length: 5 }).map((__, j) => (
              <div key={j} className="h-3 rounded bg-stone-100 animate-pulse" style={{ width: `${18 + ((i + j) % 4) * 8}%` }} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function EmptyState({ title = "Nothing here yet", message, icon: Icon = PackageOpen, action }) {
  return (
    <div data-testid="empty-state" className="rounded-lg border border-dashed border-stone-300 bg-white/60 py-16 px-6 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-700">
        <Icon className="h-7 w-7" />
      </div>
      <h3 className="font-display text-lg font-semibold text-stone-800">{title}</h3>
      {message && <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">{message}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ErrorState({ message = "Unable to load data.", onRetry }) {
  return (
    <div data-testid="error-state" className="rounded-lg border border-rose-200 bg-rose-50/60 py-14 px-6 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-rose-100 text-rose-600">
        <AlertTriangle className="h-7 w-7" />
      </div>
      <h3 className="font-display text-lg font-semibold text-rose-800">Couldn’t load this</h3>
      <p className="mx-auto mt-1 max-w-md text-sm text-rose-700/80">{message}</p>
      {onRetry && (
        <Button data-testid="btn-retry" onClick={onRetry} variant="outline" className="mt-5 gap-2">
          <RefreshCw className="h-4 w-4" /> Retry
        </Button>
      )}
    </div>
  );
}
